import React, { useState } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import FormOriginal from "./form";
import { Redirect } from "react-router-dom";
import { useAlert } from "react-alert";
function Create(props) {
  const [response, setResponse] = useState();
  const [created, setCreated] = useState(false);
  const alert = useAlert();

  const handleSubmit = (e, form) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        Axios.post(baseUrl + "products", {
          name: values.name,
          price: values.price,
          bannerImage: values.bannerImage,
          discountRate: values.discount,
          stockAmount: values.stock,
          productCode: values.productCode,
          image1: values.image1,
          image2: values.image2,
          image3: values.image3,
          category: values.cat,
          shortDescription: values.shortDesc,
          longDescription: values.longdesc,
        }).then((response) => setCreated(true));
      }
    });
  };
  if (created) {
    alert.success("Urun Basariyla Olusturuldu!");

    return <Redirect to="/allproducts/list"></Redirect>;
  }
  // if (!response) {
  //   return <div>Loading</div>;
  // }
  return (
    <FormOriginal
      title={"Ürün Oluşturucu"}
      handleSubmit={handleSubmit}
      type="Ürünü Oluştur"
    />
  );
}

export default Create;
